import { DefaultFormFieldLayout } from '@bambi/component-library/src/components/forms/DefaultFormFieldLayout/DefaultFormFieldLayout';
import type { HelperText } from '@bambi/component-library/src/components/forms/FormFieldHelperText/FormFieldHelperText';
import { Select } from '@bambi/component-library/src/components/inputs/Select/Select';
import { useMemo } from 'react';

import type { FormFieldControllerRulesProps } from './FormField/FormFieldController';
import { FormFieldController } from './FormField/FormFieldController';
import { MultiSelectContextField } from './FormField/MultiSelectContextField';
import { transportTypeOptions } from 'src/features/add-trip/ServiceDetails/transportTypeOptions';

interface SpaceTypeFieldProps {
  fieldName: string;
  label?: string;
  rules?: FormFieldControllerRulesProps;
  helperText?: HelperText;
}
export function SpaceTypeField({
  fieldName,
  rules,
  label = 'Space Type' + (rules?.required ? ' *' : ''),
  helperText,
}: SpaceTypeFieldProps) {
  return (
    <FormFieldController name={fieldName} rules={rules}>
      {({ field, fieldState }) => (
        <DefaultFormFieldLayout
          label={label}
          inputId={fieldName}
          error={fieldState.error?.message}
          helperText={helperText}
        >
          <Select
            value={field.value}
            options={transportTypeOptions}
            testIdSuffix={fieldName}
            onChange={(selected) => field.onChange(selected?.value)}
            placeholder="Select a space type"
          />
        </DefaultFormFieldLayout>
      )}
    </FormFieldController>
  );
}

export function MultiSelectSpaceTypeField({
  fieldPath,
  placeholder,
  rules,
  inline,
  disabled,
  helperText,
}: {
  fieldPath: string;
  placeholder?: string;
  rules?: FormFieldControllerRulesProps;
  inline?: boolean;
  disabled?: boolean;
  helperText?: HelperText;
}) {
  const label = useMemo(() => {
    return rules?.required ? 'Space Types *' : 'Space Types';
  }, [rules?.required]);

  return (
    <div>
      <MultiSelectContextField
        options={transportTypeOptions}
        fieldPath={fieldPath}
        label={label}
        disabled={disabled}
        rules={rules}
        inline={inline}
        helperText={helperText}
        placeholder={placeholder}
      />
    </div>
  );
}
